import Enums from "../../../../enums/enums";
import userInfo from "../../../../function/userInfo";
import Helper from "../../../../helper/merchantHelper";
import shareHelper from "../../../../helper/shareHelper";
import i18n from "../../../../locales/i18n";
import router from "../../../../router";
import * as api from "../../../../service/ApiSevice";
import contactFacade from "../../../../service/contact/contactHelper";
import store from "../../../baseController";
export const actions = {
  DoInsertMerchant({ commit, state }, message) {
    if (state.insertMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      state.insertMerchantLoadingStatus = Enums.LoadingStatusType.Loading;
      let createMerchantModel = Helper.SetCreateMerchantModel(state.merchantTemplate, message.accountingFirmId);
      const input = {
        createMerchantModel: createMerchantModel,
        userEmail: message.userModel.userEmail,
      };
      api.MerchantService.DoInsertMerchant(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          api.UserService.DoUpdateReferFriendStatusCaseCreateMerchant(res.data.merchantId).then((res) => {});
          store.dispatch("DoRefreshMerchantList").then((response) => {
            if (response) {
              store.dispatch("DoGetMerchantList");
              commit("MutationsInsertMerchant", res.data.merchantId);
            }
          });
        } else {
          store.dispatch("SetAlertMessage", {
            alertMessage: i18n.t("Notification_Verified_Merchant"),
            typeMessage: Enums.TypeComponentNoti.error,
          });
          state.insertMerchantLoadingStatus = Enums.LoadingStatusType.None;
        }
      });
    }
  },
  DoInsertSampleMerchant({ commit, state }) {
    if (state.insertSampleMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetSampleMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoInsertSampleMerchant().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          sessionStorage.setItem("emi", res.data.merchantId.PeakEncryption());
          setTimeout(() => {
            commit("MutationSetSampleMerchantId", res.data.merchantId);
            commit("MutationSetSampleMerchantLoadingStatus", Enums.LoadingStatusType.Success);
          }, 250);
        } else if (res.data.exception.code === Enums.PeakExceptionResponseCode.DemoMerchantExist) {
          if (res.data.exception.merchantDemoId > 0) {
            window.location.href = `${
              window.location.origin
            }/home?emi=${res.data.exception.merchantDemoId.PeakEncryption()}`;
          }
          commit("MutationSetSampleMerchantLoadingStatus", Enums.LoadingStatusType.Failed);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });

          commit("MutationSetSampleMerchantLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoResetMerchantTemplate({ commit, state }) {
    commit("MutationResetMerchantTemplate");
  },
  DoGetSearchedMerchantAddress({ commit, state }, input) {
    if (state.searchedMerchantAddressLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsSetSearchedMerchantAddressLoadingStatus", Enums.LoadingStatusType.Loading);
      commit("MutationsInputSearchedMerchantAddress", input);

      api.ContactService.DoGetSearchedContactAddress(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const searchedAddress = contactFacade.ToSearchedContactAddress(res.data.searchedAddress);
          commit("MutationsSearchedMerchantAddressType", searchedAddress.addressType);
          if (searchedAddress.addressType !== Enums.AddressType.NoAddress) {
            Helper.SetMerchantCreateTemplateBySearchedMerchantAddress(state.merchantTemplate, searchedAddress);
          } else {
            state.merchantTemplate = Helper.GetMerchantTemplateDefault(
              searchedAddress.taxId,
              searchedAddress.branchCode
            );
          }
        }
        commit("MutationsSetSearchedMerchantAddressLoadingStatus", Enums.LoadingStatusType.Success);
      });
    }
  },

  DoRedirectByApplicationStore({ commit, state }, ApplicationStoreType) {
   // Open a new window before starting an async call to prevent Safari from blocking window.open()
    const newWindow = window.open('');
    api.UserService.DoGetUserInfoByUserId().then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        switch (ApplicationStoreType) {
          case Enums.ApplicationStoreType.Peak:
            newWindow.location.href = `${process.env.VUE_APP_PeakEngine}home?emi=${userInfo.MerchantId().PeakEncryption()}`;
            break;
          case Enums.ApplicationStoreType.Payroll:
            newWindow.location.href = `${process.env.VUE_APP_PeakPayroll}home?emi=${userInfo.MerchantId().PeakEncryption()}`;
            break;
          case Enums.ApplicationStoreType.Board:
            newWindow.location.href = `${process.env.VUE_APP_PeakBoard}home?emi=${userInfo.MerchantId().PeakEncryption()}`;
            break;
          case Enums.ApplicationStoreType.Asset:
            newWindow.location.href = `${process.env.VUE_APP_PeakAsset}home?emi=${userInfo.MerchantId().PeakEncryption()}`;
            break;
          case Enums.ApplicationStoreType.Tax:
            newWindow.location.href = `${process.env.VUE_APP_PeakTax}home?emi=${userInfo.MerchantId().PeakEncryption()}`;
            break;
        }
      }
    });
  },
  DoGetOnBoardingMerchantSample({ commit, state }) {
    if (state.onBoardingMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      store.dispatch("IsLoading", true);
      commit("MutationSetOnBoardingMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoGetOnBoardingMerchantSample().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
        commit("MutationSetOnBoardingMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("IsLoading", false);
      });
    }
  },
  DoCreateContactMerchantSample({ commit, state }) {
    if (state.createContactMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateContactMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateContactMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateContactMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateContactMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateBankAccountMerchantSample({ commit, state }) {
    if (state.createBankAccountMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateBankAccountMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateBankAccountMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateBankAccountMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateBankAccountMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateProductMerchantSample({ commit, state }) {
    if (state.createProductMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateProductMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateProductMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateProductMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateProductMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateAllocationMerchantSample({ commit, state }) {
    if (state.createAllocationMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateAllocationMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateAllocationMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateAllocationMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateAllocationMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateQrCodeMerchantSample({ commit, state }) {
    if (state.createQrCodeMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateQrCodeMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateQrCodeMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateQrCodeMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateQrCodeMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateInvoiceMerchantSample({ commit, state }) {
    if (state.createInvoiceMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateInvoiceMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateInvoiceMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateInvoiceMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateInvoiceMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateInvoiceWithReceiptMerchantSample({ commit, state }) {
    if (state.createInvoiceWithReceiptMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateInvoiceWithReceiptMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateInvoiceWithReceiptMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateInvoiceWithReceiptMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateInvoiceWithReceiptMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateReceiptMerchantSample({ commit, state }) {
    if (state.createReceiptMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateReceiptMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateReceiptMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateReceiptMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateReceiptMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateExpenseMerchantSample({ commit, state }) {
    if (state.createExpenseMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateExpenseMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      const createExpenseMerchantSample = Enums.CreateExpenseMerchantSampleEnum.Expense;
      api.MerchantService.DoCreateExpenseMerchantSample(createExpenseMerchantSample).then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateExpenseMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateExpenseMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateExpenseLazadaSetBefore2MonthMerchantSample({ commit, state }) {
    if (state.createExpenseLazadaSetBefore2MonthMerchantSampleStatus !== Enums.LoadingStatusType.Loading) {
      commit(
        "MutationSetCreateExpenseLazadaSetBefore2MonthMerchantSampleLoadingStatus",
        Enums.LoadingStatusType.Loading
      );
      const createExpenseMerchantSample = Enums.CreateExpenseMerchantSampleEnum.LazadaSetBefore2MonthFromNow;
      api.MerchantService.DoCreateExpenseMerchantSample(createExpenseMerchantSample).then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit(
            "MutationSetCreateExpenseLazadaSetBefore2MonthMerchantSampleLoadingStatus",
            Enums.LoadingStatusType.Success
          );
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit(
            "MutationSetCreateExpenseLazadaSetBefore2MonthMerchantSampleLoadingStatus",
            Enums.LoadingStatusType.Failed
          );
        }
      });
    }
  },
  DoCreateExpenseLazadaSet2MonthMerchantSample({ commit, state }) {
    if (state.createExpenseLazadaSet2MonthMerchantSampleStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateExpenseLazadaSet2MonthMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      const createExpenseMerchantSample = Enums.CreateExpenseMerchantSampleEnum.LazadaSet2MonthFromNow;
      api.MerchantService.DoCreateExpenseMerchantSample(createExpenseMerchantSample).then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateExpenseLazadaSet2MonthMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateExpenseLazadaSet2MonthMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateJournalMerchantSample({ commit, state }) {
    if (state.createJournalMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateJournalMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateJournalMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateJournalMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateJournalMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCreateCustomDashBoardMerchantSample({ commit, state }) {
    if (state.createCustomDashBoardMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCreateCustomDashBoardMerchantSampleleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCreateCustomDashBoardMerchantSample().then((res) => {
        if (
          res.data.responseCode.IsSuccess() ||
          res.data.exception.code == Enums.PeakExceptionResponseCode.UnableCreateDefaultDataMerchantSample
        ) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCreateCustomDashBoardMerchantSampleleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCreateCustomDashBoardMerchantSampleleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoUpdateStatusMerchantSample({ commit, state }) {
    if (state.updateStatusMerchantSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetUpdateStatusMerchantSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoUpdateStatusMerchantSample().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetUpdateStatusMerchantSampleLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetUpdateStatusMerchantSampleLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoCaptureTrialBalanceByMerchant({ commit, state }) {
    if (state.captureTrialBalanceByMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetCaptureTrialBalanceByMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      api.DashBoardService.DoCaptureTrialBalanceByMerchant().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationOnBoardingMerchantSample", res.data.onBoardingMerchantSample);
          commit("MutationSetCaptureTrialBalanceByMerchantLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetCaptureTrialBalanceByMerchantLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoSuggestCreateMerchantMobile({ commit }, status) {
    commit("MutationSetSuggestCreateMerchantMobile", status);
  },
  DoValidateTransferSuperAdmin({ commit, state }, input) {
    if (state.validateTransferSuperAdminLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetValidateTransferSuperAdminLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoValidateTransferSuperAdmin(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetValidateTransferSuperAdminLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationSetValidateTransferSuperAdmin", res.data.response);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetValidateTransferSuperAdminLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoTransferSuperAdmin({ commit, state }, input) {
    if (state.transferSuperAdminLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetTransferSuperAdminLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoTransferSuperAdmin(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          setTimeout(() => {
            router.push({ name: "logout" });
          }, 5000);
          commit("MutationSetTransferSuperAdminLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetTransferSuperAdminLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoValidatePassword({ commit, state }, _password) {
    if (state.validatePasswordLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetValidatePasswordLoadingStatus", Enums.LoadingStatusType.Loading);

      const input = { password: shareHelper.CreateToken(_password) };
      api.MerchantService.DoValidatePassword(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetValidatePasswordLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationSetValidatePassword", res.data.validated);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetValidatePasswordLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
};
